import * as React from 'react';
import { getTruncationCss } from '../../utils';
import { EInputType, ESuggestType } from '../../../../types';
import { UndergroundLines } from '../UndergroundLines';
import { ItemContent } from '../ItemContent';
export var BaseSuggestionContent = function BaseSuggestionContent(props) {
  var item = props.item,
      inputType = props.inputType,
      itemsTruncation = props.itemsTruncation;
  var isMobile = !(inputType === EInputType.search || inputType === EInputType.mainpage);
  return /*#__PURE__*/React.createElement(React.Fragment, null, item.type === ESuggestType.underground && /*#__PURE__*/React.createElement(UndergroundLines, {
    lines: item.lines,
    isMobile: isMobile
  }), /*#__PURE__*/React.createElement("div", {
    className: getTruncationCss(itemsTruncation)
  }, /*#__PURE__*/React.createElement("span", {
    className: getTruncationCss(itemsTruncation, true)
  }, /*#__PURE__*/React.createElement(ItemContent, {
    item: item
  }))));
};